module.exports = __webpack_public_path__ + "img/bca.b237a538.svg";